export default __webpack_public_path__ + "bb5efa66283123d78c3c5471651a033e.svg";